import { CoreDisplayableRef, CoreEnumeration } from "./CoreModels"

export interface CoreActivityMember {
    active: boolean
    id: string
    title: string
    emailAddresses: string[] 
}

export interface CoreActivityStudent extends CoreActivityMember {
    studentGroups?: DisplayStudentGroup[]
}

export interface DisplayStudentGroup {
    title: string
    id: string
}

export interface CoreGroupStudent {
    active: boolean
    id: string
    title: string
    emailAddresses: string[] 
}

export interface CoreGroupAssignmentRole {
    active: boolean
    id: string
    title: string
    emailAddresses: string[] 
    assignmentRoleType: number
}

export interface CoreUser {
    displayName: string
    eduPrincipalNames: CoreUserEduPrincipalName[]
    active: boolean
    created: string
    modified: string
    removed?: string
    securityMarking: boolean
    givenName: string
    middleName: string
    familyName: string
    sex: number
    id: string
    hashedCivicNo: string
    hasCivicNo: boolean
    birthDate: string
    personStatus: string
    photo: string
    addresses: CoreUserAddress[]
    emails: CoreUserEmail[]
    phoneNumbers: CoreUserPhoneNumber[]
    externalIdentifiers: CorePersonExternalIdentifier[]
    removeDate?: string
}

export interface CoreUserListing {
    id: string
    active: boolean
    displayName?: string
    modified: string
    activityCount: number
    duties?: CoreUserDuty[]
    enrollments?: CoreUserEnrollment[]
    placements?: CoreUserPlacement[]
    userRelations?: CoreUserUserRelation[]
}

export interface CoreUserEduPrincipalName {
    type: number
    value: string
}

export interface CoreUserEmail {
    type: number
    value: string
}

export interface CoreUserPhoneNumber {
    type: number
    value: string
    mobile: boolean
}

export interface CoreUserAddress {
    type: number
    streetAddress: string
    postalCode: string
    locality: string
}

export interface CorePersonExternalIdentifier {
    context: string
    value: string
    globallyUnique: boolean
    active: boolean
    created: string
    modified: string
    removed: string
}

export interface CoreUserRelation {
    id: string
    relationType: number
    displayName: string
    userId: string
    active: boolean
    isChild: boolean
    schoolUnits?: CoreDisplayableRef[]
}

export interface CoreUserSchoolUnitRelations {
    duties: CoreUserDuty[]
    enrollments: CoreUserEnrollment[]
    placements: CoreUserPlacement[]
}

export interface CoreUserSchool {
    schoolUnit?: CoreDisplayableRef
}

export interface CoreUserDuty extends CoreUserSchool {
    dutyRole?: CoreEnumeration
    startDate?: string
    endDate?: string
    active: boolean
    primarySchoolStatus?: CorePrimarySchoolStatus
    dutyPercent?: number
    signature?: string
}

export interface CoreUserEnrollment extends CoreUserSchool {
    startDate?: string
    endDate?: string
    active: boolean
    primarySchoolStatus?: CorePrimarySchoolStatus
    schoolYear?: number
    educationCode?: string
    schoolType: CoreEnumeration
}

export interface CoreUserPlacement extends CoreUserSchool {
    schoolType: CoreEnumeration
    active: boolean
    startDate?: string
    endDate?: string
    reason: number
    maxWeeklyScheduledHours: number
    group?: CoreDisplayableRef
    primarySchoolStatus?: CorePrimarySchoolStatus
}

export interface CoreUserUserRelation extends CoreUserSchool {
    active: boolean
    relationType: number
}

export interface CoreUserStudentGroupListing {
    id: string
    title: string
    startDate: string
    endDate: string
    role: number
    active: boolean
    groupType: CoreEnumeration
    schoolUnit: CoreDisplayableRef
}

export interface CoreUserActivityListing {
    id: string
    active: boolean
    displayName?: string
    startDate?: string
    endDate?: string
    schoolUnitId: string
    schoolUnitDisplayName?: string
    studentGroupId?: string
    studentGroupTitle?: string
}

export interface CorePrimarySchoolStatus {
    overriddenPrimary: boolean
    status: number
}

export interface CorePersonSensitiveFields {
    civicNo?: string
}

export enum CorePersonSensitiveField {
    None = 0,
    CivicNo = 1,
}